export const amsSchema = [
  {
    id: '',
    type: 'collections',
    attributes: {
      'name': '',
      'access_permission': 'private_access',
      'primary-interest-id': '',
      'secondary-interest-id': '',
      'tertiary-interest-id': '',
    },
    required_relationships: [
      'primary-interest-id',
      'secondary-interest-id',
      'tertiary-interest-id'
    ],
    required_attributes: [
      'name'
    ],
    filters: [
      {type: 'string', label: 'name', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.name',
         label: 'Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
      { 
         key: 'attributes.access-permission',
         label: 'Access Permission',
         sortable: true,
         filterable: true,
         class: 'text-center',
         sortDirection: 'asc' 
       },
     ],
     describe_belongs_to: [
       {
         prepend: '',
         type: 'interests',
         description_attr: 'name',
         append: ' '
       },
     ],
  },
  {
    id: '',
    type: 'collection-images',
    attributes: {
      'collection-id': '',
      'is-reviewed': 'true',
      'is-of-interest': 'true'
    },
    filters: [
      {type: 'boolean', label: 'is_reviewed', model: ''},
      {type: 'boolean', label: 'is_of_interest', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.is-reviewed',
         label: 'Is Reviewed',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
      { 
         key: 'attributes.is-of-interest',
         label: 'Is Of Interest',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
     ],
     describe_belongs_to: [
       {
         prepend: ' of ',
         type: 'collections',
         description_attr: 'name',
         append: ''
       }
     ]
  },
  {
    id: '',
    type: 'brands',
    attributes: {
      'name': ''
    },
    filters: [
      {type: 'string', label: 'name', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.name',
         label: 'Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
     ]
  },
  {
    id: '',
    type: 'product-models',
    attributes: {
      'brand-id': '',
      'interest-id': '',
      'name': '',
      'description': ''
    },
    filters: [
      {type: 'string', label: 'name', model: ''},
      {type: 'string', label: 'description', model: ''},
      {type: 'string', label: 'brand_name', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.name',
         label: 'Model Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
      { 
         key: 'attributes.description',
         label: 'Description',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
     ],
     required_relationships: [
      'brand-id',
      'interest-id'
    ],
     describe_belongs_to: [
       {
         prepend: '',
         type: 'brands',
         description_attr: 'name',
         append: ''
       },
       {
         prepend: ' ',
         type: 'interests',
         description_attr: 'name',
         append: ''
       },
     ]
  },
  {
    id: '',
    type: 'interests',
    attributes: {
      'interest-id': '',
      'name': ''
    },
    filters: [
      {type: 'string', label: 'name', model: ''},
    ],
    ams_fields: [
      {
        key: 'attributes.ancestry',
        label: 'Classification',
        sortable: false,
        filterable: true,
        class: 'text-right',
        sortDirection: 'asc',
        // A column that needs custom formatting,
        formatter: 'classification',
      },
     { 
        key: 'attributes.name',
        label: 'Interest Name',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.aliases',
        label: 'Interest Aliases',
        sortable: false,
        filterable: false,
        class: 'text-left',
        sortDirection: 'asc' 
      }
    ],
  },
  {
    id: '',
    type: 'storage-spaces',
    attributes: {
      'storage-space-id': '',
      'collection-id': '',
      'location': '',
      'storage-access': ''
    },
    // required_relationships: [
    //   'collection-id'
    // ],
    required_attributes: [
      'location'
    ],
    filters: [
      {type: 'string', label: 'location', model: ''},
      {type: 'enumerated-list', label: 'storage_accesses', model: [], list: ['incoming', 'access_open', 'access_enclosed', 'outgoing']},
    ],
    ams_fields: [
      {
        key: 'attributes.ancestry',
        label: 'Classification',
        sortable: false,
        filterable: true,
        class: 'text-right',
        sortDirection: 'asc',
        // A column that needs custom formatting,
        formatter: 'storageclassification',
      },
     { 
        key: 'attributes.location',
        label: 'Location',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.storage-access',
        label: 'Storage Access',
        sortable: false,
        filterable: false,
        class: 'text-left',
        sortDirection: 'asc' 
      }
    ],
    describe_belongs_to: [
      {
        prepend: '',
        type: 'collections',
        description_attr: 'name',
        append: ''
      }
    ]
  },
  {
    id: '',
    type: 'showings',
    attributes: {
      'storage-space-id': '',
      'location': '',
      'event-name': '',
      'is-happening': 'false',
      'start-at': '',
      'end-at': '',
      'zipcode': '',
      'zipext': ''
    },
    required_relationships: [
      'storage-space-id'
    ],
    required_attributes: [
       'event-name'
    ],
    filters: [
      {type: 'string', label: 'location', model: ''},
      {type: 'string', label: 'event-name', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.event-name',
         label: 'Event Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc'
       },
      { 
         key: 'attributes.location',
         label: 'Location',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
      },
      { 
        key: 'attributes.access-permission',
        label: 'Access Permission',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
         key: 'attributes.is-happening',
         label: 'Is Happening',
         sortable: true,
         filterable: true,
         class: 'text-right',
         sortDirection: 'asc'
       },
       { 
         key: 'attributes.start-at',
         label: 'Start At',
         sortable: true,
         filterable: false,
         class: 'text-right',
         sortDirection: 'asc'       
       },
     ],
     describe_belongs_to: [
       {
         prepend: ' ',
         type: 'collections',
         description_attr: 'name',
         append: ' '
       },
       {
         prepend: ' ',
         type: 'storage-spaces',
         description_attr: 'location',
         append: ' Items'
       }
     ],
  },
  {
    id: '',
    type: 'polymorphic-references',
    attributes: {
      'reference-to-id': '',
      'reference-to-type': '',
      'relevance': '',
      'title': '',
      'summary': '',
      'url-link': ''
    },
    filters: [
      {type: 'string', label: 'title', model: ''},
    ]
  },
  {
    id: '',
    type: 'poly-integer-references',
    attributes: {
      'reference-to-id': '',
      'reference-to-type': '',
      'relevance': '',
      'title': '',
      'summary': '',
      'url-link': ''
    },
    filters: [
      {type: 'string', label: 'title', model: ''},
    ],
    ams_fields: [
      { 
        key: 'attributes.reference-to-type',
        label: 'ReferenceToType',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.relevance',
        label: 'Relevance',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.title',
        label: 'Title',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.url-link',
        label: 'URL Link',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
    ],
  },
  {
    id: '',
    type: 'features',
    attributes: {
      'title': '',
      'description': ''
    },
    filters: [
      {type: 'string', label: 'title', model: ''}
    ],
    ams_fields: [
      { 
        key: 'attributes.title',
        label: 'Title',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.description',
        label: 'Description',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { key: 'actions', label: 'Actions' }
    ],
    describe_belongs_to: [
    ]
  },
  {
    id: '',
    type: 'product-listings',
    attributes: {
      'product-model-id': '',
      'edition': 0,
      'price-cents': 0,
      'description': ''
    },
    filters: [
      {type: 'number-list', label: 'editions', model: undefined},
      {type: 'string', label: 'description', model: ''},
      {type: 'string', label: 'product_model_name', model: ''},
      {type: 'string', label: 'product_model_description', model: ''},
      {type: 'string', label: 'brand_name', model: ''}

    ],
    ams_fields: [
      { 
         key: 'attributes.edition',
         label: 'Edition',
         sortable: true,
         filterable: true,
         class: 'text-right',
         sortDirection: 'asc' 
       },
       {
         key: 'attributes.price-cents',
         label: 'Price',
         sortable: true,
         filterable: true,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return '$' + (value / 100).toFixed(2)
         }
       },
      { 
         key: 'attributes.description',
         label: 'Description',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },

    ],
    required_relationships: [
      'product-model-id'
    ],
    describe_belongs_to: [
      {
        prepend: '',
        type: 'product-models',
        description_attr: 'name',
        append: ' '
      },
      {
        prepend: '',
        type: 'brands',
        description_attr: 'name',
        append: ': '
      },
    ]
  },
  {
    id: '',
    type: 'product-items',
    attributes: {
      'storage-space-id': '',
      'product-listing-id': '',
      'description': '',
      'serial-number': 0,
      'purchased-price-cents': 0,
      'estimated-min-price-cents': 0,
      'estimated-max-price-cents': 0,
      'authenticated-min-price-cents': 0,
      'authenticated-max-price-cents': 0,
      'asking-price-cents': 0,
      'estimated-quality': 0,
      'authenticated_quality': 0
    },
    required_relationships: [
      'product-listing-id',
      'storage-space-id'
    ],
    filters: [
      {type: 'number-list', label: 'serial_numbers', model: undefined},
      {type: 'number-list', label: 'product_listing_editions', model: undefined},
      {type: 'string', label: 'product_serial_number', model: undefined},
      {type: 'string', label: 'description', model: undefined},
      {type: 'string', label: 'product_listing_description', model: ''},
      {type: 'string', label: 'product_model_name', model: ''},
      {type: 'string', label: 'product_model_description', model: ''},
      {type: 'string', label: 'brand_name', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.serial-number',
         label: 'Serial #',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc'
       },
      { 
         key: 'attributes.purchased-price-cents',
         label: 'Cost',
         sortable: true,
         filterable: true,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return '$' + (value / 100).toFixed(2)
         }
       },
       { 
         key: 'attributes.estimated-min-price-cents',
         label: 'Min Estimated Price',
         sortable: true,
         filterable: false,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return '$' + (value/ 100).toFixed(2)
         }        
       },
       { 
         key: 'attributes.estimated-max-price-cents',
         label: 'Max Estimated Price',
         sortable: true,
         filterable: false,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return '$' + (value / 100).toFixed(2)
         }
       },
       { 
         key: 'attributes.estimated-quality',
         label: 'Quality',
         sortable: true,
         filterable: false,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return (value / 100).toFixed(2) + '%'
         } 
       },
      { 
         key: 'attributes.asking-price-cents',
         label: 'Asking Price',
         sortable: true,
         filterable: false,
         class: 'text-right',
         sortDirection: 'asc',
         formatter: value => {
             return '$' + (value / 100).toFixed(2)
         }
       },
     ],
     describe_belongs_to: [
       {
         prepend: '',
         type: 'brands',
         description_attr: 'name',
         append: ': '
       },
       {
         prepend: '',
         type: 'product-models',
         description_attr: 'name',
         append: ' '
       },
       {
         prepend: '#',
         type: 'product-listings',
         description_attr: 'edition',
         append: ''
       },
       {
         prepend: ' of ',
         type: 'collections',
         description_attr: 'name',
         append: ''
       },
       {
        prepend: ' in ',
        type: 'storage-spaces',
        description_attr: 'location',
        append: ' Items'
      }
     ]
  },
  {
    id: '',
    type: 'item-image-associations',
    attributes: {
      'collection-image-id': '',
      'created-at': '',
      'product-item-id': '',
      'updated-at': '',
      'item-image-rating': '',
      'comment': ''
    },
    filters: [
      {type: 'enumerated-list', label: 'item_image_ratings', model: [], list: ['bargain', 'good', 'unicorn']},
      {type: 'string', label: 'comment', model: ''}
    ],
    ams_fields: [
      { 
        key: 'attributes.product-item-id',
        label: 'Asset ID',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.collection-image-id',
        label: 'Collection Image ID',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.item-image-rating',
        label: 'Item Image Rating',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.comment',
        label: 'Comment',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { key: 'actions', label: 'Actions' }
    ],
    describe_belongs_to: [
      {
        prepend: '',
        type: 'brands',
        description_attr: 'name',
        append: ': '
      },
      {
        prepend: '',
        type: 'product-models',
        description_attr: 'name',
        append: ' '
      },
      {
        prepend: '#',
        type: 'product-listings',
        description_attr: 'edition',
        append: ''
      },
      {
        prepend: ' of ',
        type: 'collections',
        description_attr: 'name',
        append: ''
      },
      {
       prepend: ' in ',
       type: 'storage-spaces',
       description_attr: 'location',
       append: ' Items'
     }
    ]
  },
  {
    id: '',
    type: 'actor-roles',
    attributes: {
      'work-group-id': '',
      'profile-id': '',
      'role': 'manager',
      'can-read': true,
      'can-create': true,
      'can-update': true,
      'can-destroy': false
    },
    filters: [
      {type: 'enumerated-list', label: 'roles', model: [], list: ['manager', 'worker', 'auditor', 'observer', 'consumer']},
      {type: 'boolean', label: 'can_read', model: ''},
      {type: 'boolean', label: 'can_create', model: ''},
      {type: 'boolean', label: 'can_update', model: ''},
      {type: 'boolean', label: 'can_destroy', model: ''}
    ],
    ams_fields: [
      { 
        key: 'attributes.role',
        label: 'Role',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.can-create',
        label: 'Can Create',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.can-read',
        label: 'Can Read',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.can-update',
        label: 'Can Update',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.can-destroy',
        label: 'Can Destroy',
        sortable: true,
        filterable: true,
        class: 'text-center',
        sortDirection: 'asc' 
      },
      { key: 'actions', label: 'Actions' }
    ],
    describe_belongs_to: [
      {
        prepend: '',
        type: 'work-groups',
        description_attr: 'name',
        append: ' '
      },
      {
        prepend: '',
        type: 'collections',
        description_attr: 'name',
        append: ' '
      },
      {
        prepend: ' ',
        type: 'profiles',
        description_attr: 'nickname',
        append: ' '
      },
      {
        prepend: ' of ',
        type: 'users',
        description_attr: 'email',
        append: ''
      }
    ]
  },
  {
    id: '',
    type: 'work-groups',
    attributes: {
      'collection-id': '',
      'name': '',
      'group-function': 'inventory'
    },
    filters: [
      {
        type: 'string',
        label: 'names',
        model: ''
      }
    ],
    ams_fields: [
      { 
         key: 'attributes.name',
         label: 'Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
     ],
     describe_belongs_to: [
       {
         prepend: '',
         type: 'brands',
         description_attr: 'name',
         append: ': '
       },
       {
         prepend: '',
         type: 'product-models',
         description_attr: 'name',
         append: ' '
       },
       {
         prepend: '#',
         type: 'product-listings',
         description_attr: 'edition',
         append: ''
       },
       {
         prepend: '',
         type: 'collections',
         description_attr: 'name',
         append: ''
       }
     ]
  },
  {
    id: '',
    type: 'profiles',
    attributes: {
      'user_id': '', 
      'nickname': '',
      'unique-alias': '',
      'mobile': '',
      'location': '',
      'zipcode': '',
      'zipext': ''
    },
    filters: [
      {type: 'string', label: 'text', model: ''}
    ],
    ams_fields: [
      { 
        key: 'attributes.nickname',
        label: 'Nickname',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.unique-alias',
        label: 'Alias ID',
        sortable: true,
        filterable: true,
        class: 'text-left',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.mobile',
        label: 'Mobile',
        sortable: true,
        filterable: true,
        class: 'text-right',
        sortDirection: 'asc' 
      },
      { 
        key: 'attributes.location',
        label: 'Location',
        sortable: true,
        filterable: true,
        class: 'text-right',
        sortDirection: 'asc' 
      },
      {
        key: 'attributes.zipcode',
        label: 'Zipcode',
        sortable: true,
        filterable: true,
        sortDirection: 'asc'
      },
      { key: 'actions', label: 'Actions' }
    ],
    describe_belongs_to: [
      {
        prepend: ' ',
        type: 'users',
        description_attr: 'name',
        append: ' '
      },
      {
        prepend: ' of ',
        type: 'users',
        description_attr: 'email',
        append: ''
      }
    ]
  },
  {
    id: '',
    type: 'users',
    attributes: {
      'name': '',
      'password': '',
      'password-confirmation': ''
    },
    filters: [
      {type: 'string', label: 'text', model: ''}
    ],
    ams_fields: [
      { 
         key: 'attributes.name',
         label: 'Name',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc' 
       },
       {
         key: 'attributes.email',
         lable: 'Email',
         sortable: true,
         filterable: true,
         class: 'text-left',
         sortDirection: 'asc'
       }
     ]
  }
]